export default __webpack_public_path__ + "static/media/FAQIcon.8a966a1c.svg";